import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/Bharatham Logo Dark Transparent Compressed.png"

export default function NavBar() {
	const [navbar, setNavbar] = useState(false);

	function useOutsideAlerter(ref) {
		useEffect(() => {

			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setNavbar(false)
				}
			}
			// Bind the event listener
			document.addEventListener("mousedown", handleClickOutside);
			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener("mousedown", handleClickOutside);
			};
		}, [ref]);
	}

	const wrapperRef = useRef(null);
	useOutsideAlerter(wrapperRef);

	return (
		<nav ref={wrapperRef} className="absolute top-0 z-10 bg-black w-full shadow-md border-b border-gray-600 glass-effect">
			<div className="justify-between px-4 mx-auto lg:max-w-7xl md:items-center md:flex md:px-8">
				<div>
					<div className="flex items-center justify-between py-3 md:py-3 md:block">
						<Link to="/" className="select-none">
							{/* <h2 className="select-none text-gray-200 text-xl font-bold">Bharatham</h2> */}
							<img src={Logo} alt="Bharatham-Logo" className="h-12" />
						</Link>
						<div className="md:hidden">
							<button
								className="p-2 text-gray-400 rounded-md outline-none"
								onClick={() => setNavbar(!navbar)}
							>
								{navbar ? (
									<svg
										xmlns="http://www.w3.org/2000/svg"
										className="w-6 h-6"
										viewBox="0 0 20 20"
										fill="currentColor"
									>
										<path
											fillRule="evenodd"
											d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
											clipRule="evenodd"
										/>
									</svg>
								) : (
									<svg
										xmlns="http://www.w3.org/2000/svg"
										className="w-6 h-6"
										fill="none"
										viewBox="0 0 24 24"
										stroke="currentColor"
										strokeWidth={2}
									>
										<path
											strokeLinecap="round"
											strokeLinejoin="round"
											d="M4 6h16M4 12h16M4 18h16"
										/>
									</svg>
								)}
							</button>
						</div>
					</div>
				</div>
				<div>
					<div
						className={`flex-1 justify-self-center pb-3 mt-8 md:block md:pb-0 md:mt-0 ${navbar ? "block" : "hidden"
							}`}
					>
						<ul className="items-center justify-center space-y-8 md:flex md:space-x-10 md:space-y-0">
							<li className="text-gray-200 hover:text-gray-300" onClick={() => setNavbar(false)}>
								<Link to="/events">Events</Link>
							</li>
							<li className="text-gray-200 hover:text-gray-300" onClick={() => setNavbar(false)}>
								<Link to="/scoreboard">Scoreboard</Link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</nav>
	);
}